import { securePost } from '@/libs/helpers/apiClient';
import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import Head from 'next/head';
import { useLoader } from '@/contexts/LoaderContext';
import styles from '@/styles/Login.module.css';
export default function Login() {
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const { showLoader, hideLoader } = useLoader();

    useEffect(() => {
        document.body.classList.add('background2');
        return () => {
            document.body.classList.remove('background2');
        };
    }, []);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        showLoader();
        try {
            if (!username || !password) {
                setMessage('Please enter username and password');
                hideLoader();
                return
            }
            const response = await securePost('/api/login', { username, password });
            const data = await response.json();
            if (data.status == 1) {
                Cookies.set('user', JSON.stringify(data.data));
                setMessage('Login successful!');
                window.location.href = '/';
            } else {
                setMessage(data.message || 'Login failed');
                hideLoader();
            }
        } catch (error) {
            setMessage('An error occurred');
            hideLoader();
        }
    };

    return (
        <>
            <Head>
                <title>Dollar Day - Login</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.ico" />
            </Head>
            <div className={styles.loginContainer}>
                <div className={styles.loginPopup}>
                    <h1>Login with your E-Code</h1>
                    <p className={styles.subtitle}>Your information is safe with us.</p>

                    <form onSubmit={handleLogin}>
                        <input
                            type="text"
                            placeholder="Enter E-Code"
                            value={username}
                            onChange={(e) => (setUserName(e.target.value), setMessage(""))}
                        />
                        <div className={styles.passwordContainer}>
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter Password"
                                value={password}
                                onChange={(e) => (setPassword(e.target.value), setMessage(""))}
                            />
                            <button
                                type="button"
                                className={styles.eyeButton}
                                onClick={() => setShowPassword(!showPassword)}
                                aria-label={showPassword ? "Hide password" : "Show password"}
                            >
                                {showPassword ? (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                ) : (
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.45703 12C3.73128 7.94288 7.52159 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C20.2672 16.0571 16.4769 19 11.9992 19C7.52159 19 3.73128 16.0571 2.45703 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M11.9992 15C13.6561 15 14.9992 13.6569 14.9992 12C14.9992 10.3431 13.6561 9 11.9992 9C10.3424 9 8.99924 10.3431 8.99924 12C8.99924 13.6569 10.3424 15 11.9992 15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                )}
                            </button>
                        </div>
                        {message && <p className={styles.message}>{message}</p>}
                        <button type="submit">Login Now</button>
                    </form>
                </div>
            </div>
        </>
    )
}